import React from 'react';

const ListHeader = ( { title, children }) => {
  return (
    <div className="grid tight collapse480">
        <div className="col s1of1">
        <h1 className="text-red text-32">{typeof children === 'function' ? (title()) : (title)}</h1>                           
            {children}            
        </div>          
    </div>      
  );
}


export default ListHeader;